export default __webpack_public_path__ + "static/media/globe_texture.5c184516.webp";